import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from "react-intl";

import {black500} from "assets/jss/main";

import {capitalize} from "utils/capitalize";
import {UserAgentUtils} from "utils/useragent";

GreetMessage.propTypes = {
    member: PropTypes.object,
};

function getGreetingKey() {
    const hours = new Date().getHours();

    if (hours < 6) {
        return "night";
    }

    if (hours > 12 && hours <= 17) {
        return "afternoon";
    }

    if (hours > 17) {
        return "evening";
    }

    return "morning";
}

function GreetMessage({member}) {
    const intl = useIntl();

    if (!member) {
        return null;
    }

    const givenName = capitalize(member?.givenName ?? "");

    return (
        <div style={{
            fontSize: UserAgentUtils.isMobile() ? '22px' : "24px",
            fontWeight: 700,
            color: black500,
            lineHeight: 1.2
        }}>
            {intl.formatMessage({ id: `dashboard.title.greeting.${getGreetingKey()}` }, { name: givenName })}
        </div>
    );
}

export default GreetMessage;
